import { Component } from '@angular/core';
import { CourseCatalogueDetailsCardComponent } from '../../course-catalogue-details-card/course-catalogue-details-card.component';

@Component({
  selector: 'app-regular-course-included-exposition',
  standalone: true,
  imports: [CourseCatalogueDetailsCardComponent],
  templateUrl: './regular-course-included-exposition.component.html',
})
export class RegularCourseIncludedExpositionComponent {
  weProvideItems = [
    {
      title: $localize`A holiday camp from Monday to Friday (not on public holidays!)`,
    },
    { title: $localize`Pre-care from 8 a.m. and after-care until 6 p.m` },
    {
      title: $localize`All activities and materials needed for the camp`,
    },
    {
      title: $localize`Enthusiastic guidance by a Skillz monitor per group of max. 12 participants`,
    },
    {
      title: $localize`Additional support from a main monitor and a regional manager`,
    },
    {
      title: $localize`Possibility of cancellation up to one week before start date (with administrative costs of €30)`,
    },
  ];

  youProvideItems = [
    { title: $localize`A packed lunch` },
    { title: $localize`A drinking bottle` },
    { title: $localize`Clothes in which you can move and play comfortably` },
    {
      title: $localize`Depending on your theme, something can be added to this. You will be informed of this one week before the camp by email.`,
    },
  ];
}
